<template>
  <div>
    <b-sidebar
      id="sidebar-product"
      v-model="showSlide"
      backdrop
      shadow
      backdrop-variant="dark"
      right
      aria-labelledby="sidebar-product-title"
      @hidden="hide()"
      no-header
    >
      <template>
        <div v-if="isLoading">
          <OtherLoading />
        </div>
        <div v-else>
          <div class="m-2 d-flex justify-content-between align-items-center">
            <label class="header-text">รายการสินค้า</label>
            <label class="pointer" @click="hide()"
              ><b-icon icon="x-circle-fill"></b-icon
            ></label>
          </div>
          <div class="p-2 detail-panel">
            <div class="d-flex">
              <b-input-group>
                <b-form-input
                  class="input-search"
                  placeholder="ค้นหา"
                  @keypress="handlePushMessage"
                  v-model="filter.search"
                ></b-form-input>
              </b-input-group>
              <b-button class="search-circle-bth">
                <span class="icon-input m-auto pr-2">
                  <font-awesome-icon
                    icon="search"
                    title="View"
                    @click="search"
                  />
                </span>
              </b-button>
            </div>
          </div>

          <div class="product-list-container">
            <b-row class="mx-0">
              <b-col
                class="px-0 py-1 tab-product text-center pointer"
                :style="
                  tabCurrent == 1
                    ? `color: ${$store.state.colorPrimary};${$store.state.backgroundSecondary};border-bottom: 5px solid ${$store.state.colorPrimary};`
                    : ''
                "
                @click="selectTab(1)"
              >
                <p>ทั้งหมด</p>
                <p>({{ (totalProduct + totalSpa) | numeral("0,0") }})</p>
              </b-col>
              <b-col
                v-if="booth"
                class="px-0 py-1 tab-product text-center pointer"
                :style="
                  tabCurrent == 2
                    ? `color: ${$store.state.colorPrimary};${$store.state.backgroundSecondary};border-bottom: 5px solid ${$store.state.colorPrimary};`
                    : ''
                "
                @click="selectTab(2)"
              >
                <p>สินค้า</p>
                <p>({{ totalProduct | numeral("0,0") }})</p>
              </b-col>
              <b-col
                v-if="spa"
                class="px-0 py-1 tab-product text-center pointer"
                :style="
                  tabCurrent == 3
                    ? `color: ${$store.state.colorPrimary};${$store.state.backgroundSecondary};border-bottom: 5px solid ${$store.state.colorPrimary};`
                    : ''
                "
                @click="selectTab(3)"
              >
                <p>บริการและสปา</p>
                <p>({{ totalSpa | numeral("0,0") }})</p>
              </b-col>
            </b-row>
            <template>
              <div class="product-items-list">
                <div
                  v-for="product in tabCurrent == 1
                    ? productList.all
                    : tabCurrent == 2
                    ? productList.booth
                    : productList.spa"
                  :key="product.id"
                >
                  <b-row class="mx-0 py-2 border-bottom">
                    <b-col
                      cols="1"
                      class="pl-4 d-flex justify-content-center align-items-center"
                    >
                      <b-form-checkbox
                        v-model="productSelect"
                        :value="product.barcode"
                      ></b-form-checkbox>
                    </b-col>
                    <b-col cols="7" class="pl-0">
                      <p>
                        <strong>{{ product.barcode }}</strong>
                      </p>
                      <p class="text-sub">{{ product.name }}</p>
                    </b-col>
                    <b-col
                      cols="3"
                      class="pl-4 d-flex justify-content-center align-items-center"
                      ><p class="float-right text-nowrap">
                        {{ product.price | numeral("0,0.00") }}
                      </p></b-col
                    >
                  </b-row>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>

      <template #footer>
        <div class="mt-2">
          <b-pagination
            v-model="filter.page"
            :total-rows="
              tabCurrent == 1
                ? totalAll
                : tabCurrent == 2
                ? totalProduct
                : totalSpa
            "
            :per-page="5"
            class="m-md-0 page-item"
            @change="pagination"
            align="center"
            size="sm"
            limit="4"
          ></b-pagination>
        </div>
        <div class="text-center mt-2">
          <div class="mb-2 w-100">
            <b-button
              :disabled="!productSelect"
              class="radius-btn w-75"
              @click="selectProduct"
            >
              <span>เลือก</span>
            </b-button>
          </div>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import OtherLoading from "@/components/loading/OtherLoading";
import InputText from "@/components/inputs/InputText";
export default {
  name: "SlideProduct",
  components: { OtherLoading, InputText },
  props: {
    booth: {
      type: Boolean,
      isRequired: true,
    },
    spa: {
      type: Boolean,
      isRequired: true,
    },
  },
  data() {
    return {
      showSlide: false,
      filter: {
        search: "",
        type: 0,
        page: 1,
      },
      productSelect: "",
      productList: {
        all: [],
        booth: [],
        spa: [],
      },
      totalAll: 0,
      totalProduct: 0,
      totalSpa: 0,
      tabCurrent: 0,
      isLoading: false,
    };
  },
  watch: {
    productSelect(val) {
      console.log(val);
    },
  },
  methods: {
    async show() {
      this.tabCurrent = 1;
      this.showSlide = true;
      this.isLoading = true;
      await this.search();
      this.isLoading = false;
    },
    hide() {
      this.showSlide = false;
      this.productSelect = "";
      this.filter.page = 1;
    },
    search() {
      this.GetSearchAll();
      this.GetSearchBooth();
      this.GetSearchSpa();
    },
    async GetSearchAll() {
      let body = {
        articleType: "",
        ah2_id: null,
        ah3_id: null,
        ah4_id: null,
        search: this.filter.search,
        skip: (this.filter.page - 1) * 5,
        take: 5,
        spa: this.spa,
        booth: this.booth,
      };
      await this.axios
        .post(`${this.$baseUrl}/product/search_product`, body)
        .then((data) => {
          if (data.result == 1) {
            this.productList.all = data.detail;
            this.totalAll = data.total_count;
          }
        });
    },
    async GetSearchBooth() {
      let body = {
        articleType: "ZFIN",
        ah2_id: null,
        ah3_id: null,
        ah4_id: null,
        search: this.filter.search,
        skip: (this.filter.page - 1) * 5,
        take: 5,
        spa: this.spa,
        booth: this.booth,
      };
      if (this.booth) {
        await this.axios
          .post(`${this.$baseUrl}/product/search_product`, body)
          .then((data) => {
            if (data.result == 1) {
              this.productList.booth = data.detail;
              this.totalProduct = data.total_count;
            }
          });
      }
    },
    async GetSearchSpa() {
      let body = {
        articleType: "ZPACK",
        ah2_id: null,
        ah3_id: null,
        ah4_id: null,
        search: this.filter.search,
        skip: (this.filter.page - 1) * 5,
        take: 5,
        spa: this.spa,
        booth: this.booth,
      };
      if (this.spa) {
        await this.axios
          .post(`${this.$baseUrl}/product/search_product`, body)
          .then((data) => {
            if (data.result == 1) {
              this.productList.spa = data.detail;
              this.totalSpa = data.total_count;
            }
          });
      }
    },
    handlePushMessage(e) {
      if (e.keyCode === 13 && !e.shiftKey) {
        e.preventDefault();
        this.GetSearchAll();
        this.GetSearchBooth();
        this.GetSearchSpa();
      }
    },
    selectTab(tab) {
      this.tabCurrent = tab;
      if (tab === 1) {
        this.GetSearchAll();
      } else if (tab === 2) {
        this.GetSearchBooth();
      } else if (tab === 3) {
        this.GetSearchSpa();
      }
      this.filter.page = 1;
    },
    pagination(Page) {
      this.filter.page = Page;
      this.GetSearchAll();
      this.GetSearchBooth();
      this.GetSearchSpa();
    },
    async selectProduct() {
      let body = {
        user_guid: this.$cookies.get("user_guid"),
        barcode: this.productSelect,
        product_id: [],
      };
      await this.$emit("onSelectProduct", body);
      this.hide();
    },
  },
};
</script>

<style scoped>
::v-deep .nav-pills .nav-link {
  border-radius: 0rem;
  background-color: #dedede !important;
  white-space: nowrap;
  color: var(--font-primary-color);
  padding: 5px;
  border-bottom: 5px solid #dedede !important;
}
::v-deep .nav-pills .nav-link.active {
  background-color: var(--secondary-color) !important;
  white-space: nowrap;
  color: var(--font-primary-color);
  padding: 5px;
  border-bottom: 5px solid var(--primary-color) !important;
}
.product-items-list {
  min-height: auto;
}
@media only screen and (min-width: 375px) and (max-width: 414px) {
  .product-items-list {
    min-height: unset;
    max-height: auto;
    overflow-x: auto;
  }
}
@media only screen and (min-width: 414px) and (max-width: 768px) {
  .product-items-list {
    min-height: unset;
    max-height: auto;
    overflow-x: auto;
  }
}
.tab-product {
  color: #fff;
  background-color: #dedede;
  border-bottom: 5px solid #dedede;
}
</style>
